import { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { getCachedState, initUserState } from "./stateContext";

export function ConsentGuard({ children }) {
    const location = useLocation();
    const [stateCode, setStateCode] = useState(getCachedState);

    // Fetch and cache state once; update component state when resolved
    useEffect(() => {
        let mounted = true;
        initUserState().then(() => { if (mounted) setStateCode(getCachedState()); }).catch(() => {});
        return () => { mounted = false; };
    }, []);

    const maybeShowBanner = useCallback(() => {
        if (location.pathname === '/cookie-policy') return; // Don't show banner on cookie policy page
        if (stateCode !== "CA" && stateCode !== 'Not available') return; // Only show for CA or unknown state
        const choiceMade = !!localStorage.getItem('silktideCookieBanner_InitialChoice');

        if (!choiceMade) window.silktideCookieBannerManager?.openBanner?.();
    }, [location.pathname, stateCode]);

    // Check for consent banner display in every route change
    useEffect(() => {
        maybeShowBanner();
    }, [maybeShowBanner]);

    // Try to show banner when Silktide manager becomes available
    useEffect(() => {
    window.addEventListener("silktide:ready", maybeShowBanner);
        return () => window.removeEventListener("silktide:ready", maybeShowBanner);
    }, [maybeShowBanner]);

    return children;
}
